import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import * as insightApi from '@hotjar/webapp/domains/highlights/api';

type ApiFunction = typeof insightApi.getHighlightsList;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useHighlightsList(
  siteId: string | null,
  collectionId: Parameters<typeof insightApi.getHighlightsList>[1],
  queryParams: Parameters<typeof insightApi.getHighlightsList>[2],
): UseQueryResult<ApiResponseType, AxiosError> {
  return useQuery<ApiResponseType, AxiosError>(
    [
      insightApi.HIGHLIGHTS_LIST_QUERY_KEY,
      siteId,
      collectionId,
      // NOTE: set is not taken into account properly by React query
      // even if it's not mutated but created from scratch every time it's
      // updates, it doesn't invalidate cache
      { ...queryParams, labels: Array.from(queryParams.labels ?? []) },
    ],
    () => insightApi.getHighlightsList(siteId as string, collectionId, queryParams),
    {
      enabled: siteId !== null,
      staleTime: 5 * 60 * 1000, // 5 minutes.
      refetchOnWindowFocus: 'always',
      keepPreviousData: true,
    },
  );
}
